function enhanceScrollableTable(wrapper) {
  const isScrollable = wrapper.scrollWidth > wrapper.clientWidth;
  const messages = Decidim.config.config.messages;
  if (isScrollable) {
    wrapper.setAttribute("tabindex", "0");
    wrapper.setAttribute("role", "region");
    wrapper.setAttribute(
      "aria-label",
      messages.table.a11y.horizontalScrolling
    );
  } else {
    wrapper.removeAttribute("tabindex");
    wrapper.removeAttribute("role");
    wrapper.removeAttribute("aria-label");
  }
}
const observer = new ResizeObserver((entries) => {
  for (const entry of entries) {
    enhanceScrollableTable(entry.target);
  }
});
window.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".table-scroll").forEach((wrapper) => {
    enhanceScrollableTable(wrapper);
    observer.observe(wrapper);
  });
});
